import React from 'react'

const getSnapshot = () => navigator.onLine
const getServerSnapshot = () => false
const subscribe = (callback) => {
  window.addEventListener('online', callback)
  window.addEventListener('offline', callback)
  return () => {
    window.removeEventListener('online', callback)
    window.removeEventListener('offline', callback)
  }
}

export const useNetworkStatus = () =>
  React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
